import React from 'react';

import { Text } from '@chakra-ui/react';

import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { LearnMoreFieldType } from 'containers/SharedState/types';

interface ILearnMoreLink {
  label: string;
  field: LearnMoreFieldType;
  value?: boolean;
}

export const LearnMoreInlineLink = (props: ILearnMoreLink) => {
  const { label, field } = props;
  const { setLearnMore } = useKnowledgeBase();
  return (
    <Text
      color="primary"
      display="inline-block"
      onClick={() => setLearnMore(field)}
      cursor="pointer"
    >
      {label}
    </Text>
  );
};
